"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable react/button-has-type */
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var defs_1 = require("../Form/defs");
var utils_1 = require("../utils");
var ConfigProvider_1 = require("../ConfigProvider");
var icons_1 = require("../icons");
var hooks_1 = require("../utils/hooks");
function Button(props) {
    var children = props.children, _a = props.type, type = _a === void 0 ? 'default' : _a, _b = props.danger, danger = _b === void 0 ? false : _b, size = props.size, icon = props.icon, endIcon = props.endIcon, _c = props.htmlType, htmlType = _c === void 0 ? 'button' : _c, loading = props.loading, onClick = props.onClick, disabled = props.disabled, className = props.className, as = props.as, rootHtmlProps = props.rootHtmlProps, style = props.style, rest = tslib_1.__rest(props, ["children", "type", "danger", "size", "icon", "endIcon", "htmlType", "loading", "onClick", "disabled", "className", "as", "rootHtmlProps", "style"]);
    var formInfo = defs_1.useFormInfo();
    var finalDisabled = disabled || loading; // loading 的时候按钮也应该被禁用
    var prefix = ConfigProvider_1.usePrefix('btn');
    var typePrefix = utils_1.concat(prefix, type);
    var dangerPrefix = utils_1.concat(prefix, 'danger');
    var sizePrefix = utils_1.concat(typePrefix, size !== null && size !== void 0 ? size : formInfo.size);
    var loadingPrefix = utils_1.concat(typePrefix, 'loading');
    var contentPrefix = utils_1.concat(prefix, 'content');
    var iconPrefix = utils_1.concat(contentPrefix, 'icon');
    var endIconPrefix = utils_1.concat(contentPrefix, 'endicon');
    var classname = classnames_1.default(prefix, typePrefix, sizePrefix, danger && dangerPrefix, loading && loadingPrefix, finalDisabled && utils_1.concat(prefix, 'disabled'), className, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    var spinCls = hooks_1.useAnimationCls().spinCls;
    var startIcon = loading
        ? react_1.default.createElement("span", { className: iconPrefix },
            react_1.default.createElement(icons_1.LoadingThinIcon, { className: spinCls }))
        : icon && react_1.default.createElement("span", { className: iconPrefix }, icon);
    var handleClick = react_1.useCallback(function (e) {
        var _a;
        if (finalDisabled)
            return;
        (_a = rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.onClick) === null || _a === void 0 ? void 0 : _a.call(rootHtmlProps, e);
        if (e.defaultPrevented)
            return;
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [rootHtmlProps, onClick, finalDisabled]);
    var rootProps = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, rootHtmlProps), { type: htmlType, className: classname, style: tslib_1.__assign(tslib_1.__assign({}, style), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.style), onClick: ((rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.onClick) || onClick) && handleClick, disabled: finalDisabled }), rest);
    return react_1.createElement(as !== null && as !== void 0 ? as : 'button', rootProps, (react_1.default.createElement("span", { className: contentPrefix },
        startIcon,
        children && react_1.default.createElement("span", null, children),
        endIcon && react_1.default.createElement("span", { className: endIconPrefix }, endIcon))));
}
exports.default = Button;
//# sourceMappingURL=index.js.map